module.exports = __webpack_public_path__ + "img/weal_content_8.b7f450d0.png";